module.exports = __webpack_public_path__ + "img/engineering.b4f92e14.png";